// File: components/QuoteForm.js
import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  doc,
  updateDoc,
  addDoc,
  getDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import QuoteContent from "./QuoteContent";

const paymentOptions = {
  "Half/Half": `A DEPOSIT OF ½ OF THE FULL AMOUNT ABOVE WILL BE REQUIRED AT ACCEPTANCE OF THE PROPOSAL. THE REMAINING BALANCE WILL BE BILLED UPON WORK COMPLETION. PAYMENT FOR SERVICES IS DUE UPON RECEIPT OF INVOICE.`,
  "1/2 - Progress": `A DEPOSIT OF ½ OF THE FULL AMOUNT ABOVE WILL BE REQUIRED AT ACCEPTANCE OF THE PROPOSAL. THE REMAINING BALANCE WILL BE PROGRESS BILLED. PAYMENT FOR SERVICES IS DUE UPON RECEIPT OF INVOICE.`,
  "1/3 - Progress": `A DEPOSIT OF 1/3 OF THE FULL AMOUNT ABOVE WILL BE REQUIRED AT ACCEPTANCE OF THE PROPOSAL. THE REMAINING BALANCE WILL BE PROGRESS BILLED. PAYMENT FOR SERVICES IS DUE UPON RECEIPT OF INVOICE.`,
  "1/3 - 1/3": `A DEPOSIT OF 1/3 OF THE FULL AMOUNT ABOVE WILL BE REQUIRED AT ACCEPTANCE OF THE PROPOSAL. ANOTHER DEPOSIT OF 1/3 OF THE FULL AMOUNT ABOVE WILL BE REQUIRED AT APPROX 7 DAYS BEFORE THE START OF THE JOB. THE REMAINING BALANCE WILL BE DUE UPON COMPLETION. PAYMENT FOR SERVICES IS DUE UPON RECEIPT OF INVOICE.`,
  Other: ""
};

const warrantyOptions = {
  "Standard 1-Year": `All material is guaranteed to be as specified. All work to be completed in a workmanlike manner according to standard practices. Any alteration or deviation from the above specifications involving extra costs will be done upon a written change order. The costs will become an extra charge over and above the price. No guarantees are expressed or implied regarding the eﬀectiveness of work. Performance may be delayed by circumstances beyond the contractor’s control such as weather, strikes, or any other acts not controlled by Dynasty Community Services LLC.

Dynasty Community Services LLC performs all work under the guidelines of the state and/or county where work is being performed. Dynasty Community Services abides by local laws and jurisdictions and complies with all applicable permit requirements of the state and/or county where work is being performed. If permits are required to be pulled, then the cost for those permits is the responsibility of the Association.

Dynasty Community Services LLC is not responsible for direct or incidental damage to any items such as (but not limited to) hoses, sprinkler or underground wiring systems, or loss of any nature to property except in cases of willful misconduct or gross negligence. Any damage or suspected damage must be reported to the contractor within 48 hours for any consideration whatsoever. If Dynasty Community Services LLC assumes responsibility, an opportunity must be provided for the contractor to correct the damage. Proposal pricing does not include alterations of the scope of work due to buried or concealed obstacles. Customer shall be responsible for the procurement of all permits and approvals required. Any requested or required construction specifications that require a change to the scope of work specified in the contract shall result in changes in pricing to complete the work.

Dynasty Community Services LLC is proud to provide a One Year Limited Workmanship Warranty, guaranteeing the quality of workmanship that we provide to our valued customers ("Client").

For a period of twelve (12) months from the completion date of the work performed pursuant to the contract, Dynasty Community Services LLC warrants against the workmanship of the installation of the work proposed.

This warranty does not cover damages to or failure of the products caused by the following: structural defects, failure or settlement; improper drainage (standing water); fire, explosion, chemicals, fumes or vapors; and damage or defects caused in whole or in part by reason of acts of God, flood, extreme weather conditions, vandalism, negligence, or any other similar causes beyond the control of the contractor.

This Warranty is applicable only to the Association listed above.`,
  "Extended 2-Year": `All material is guaranteed to be as specified. All work to be completed in a workmanlike manner according to standard practices. Any alteration or deviation from the above specifications involving extra costs will be done upon a written change order. The costs will become an extra charge over and above the price. No guarantees are expressed or implied regarding the eﬀectiveness of work. Performance may be delayed by circumstances beyond the contractor’s control such as weather, strikes, or any other acts not controlled by Dynasty Community Services LLC.

Dynasty Community Services LLC performs all work under the guidelines of the state and/or county where work is being performed. Dynasty Community Services abides by local laws and jurisdictions and complies with all applicable permit requirements of the state and/or county where work is being performed. If permits are required to be pulled, then the cost for those permits is the responsibility of the Association.

Dynasty Community Services LLC is not responsible for direct or incidental damage to any items such as (but not limited to) hoses, sprinkler or underground wiring systems, or loss of any nature to property except in cases of willful misconduct or gross negligence. Any damage or suspected damage must be reported to the contractor within 48 hours for any consideration whatsoever. If Dynasty Community Services LLC assumes responsibility, an opportunity must be provided for the contractor to correct the damage. Proposal pricing does not include alterations of the scope of work due to buried or concealed obstacles. Customer shall be responsible for the procurement of all permits and approvals required. Any requested or required construction specifications that require a change to the scope of work specified in the contract shall result in changes in pricing to complete the work.

Dynasty Community Services LLC is proud to provide a One Year Limited Workmanship Warranty, guaranteeing the quality of workmanship that we provide to our valued customers ("Client").

For a period of twelve (12) months from the completion date of the work performed pursuant to the contract, Dynasty Community Services LLC warrants against the workmanship of the installation of the work proposed.

This warranty does not cover damages to or failure of the products caused by the following: structural defects, failure or settlement; improper drainage (standing water); fire, explosion, chemicals, fumes or vapors; and damage or defects caused in whole or in part by reason of acts of God, flood, extreme weather conditions, vandalism, negligence, or any other similar causes beyond the control of the contractor.

This Warranty is applicable only to the Association listed above.`,
  "Limited 6-Month": `All material is guaranteed to be as specified. All work to be completed in a workmanlike manner according to
standard practices. Any alteration or deviation from the above specifications involving extra costs will be
done upon a written change order. The costs will become an extra charge over and above the price. No
guarantees are expressed or implied regarding the eﬀectiveness of work. Performance may be delayed by
circumstances beyond the contractor’s control such as weather, strikes, or any other acts not controlled by
Dynasty Community Services LLC.

Dynasty Community Services LLC performs all work under the guidelines of the state and/or county where
work is being performed. Dynasty Community Services abides by local laws and jurisdictions and complies
with all applicable permit requirements of the state and/or county where work is being performed. If permits
are required to be pulled, then the cost for those permits is the responsibility of the Association.

Dynasty Community Services LLC is not responsible for direct or incidental damage to any items such as (but
not limited to) hoses, sprinkler or underground wiring systems, or loss of any nature to property except in
cases of willful misconduct or gross negligence. Any damage or suspected damage must be reported to the
contractor within 48 hours for any consideration whatsoever. If Dynasty Community Services LLC assumes
responsibility, an opportunity must be provided for the contractor to correct the damage. Proposal pricing
does not include alterations of the scope of work due to buried or concealed obstacles. Customer shall be
responsible for the procurement of all permits and approvals required. Any requested or required
construction specifications that require a change to the scope of work specified in the contract shall result in
changes in pricing to complete the work.

Dynasty Community Services LLC is proud to provide a One Year Limited Workmanship Warranty,
guaranteeing the quality of workmanship that we provide to our valued customers ("Client").

For a period of twelve (12) months from the completion date of the work performed pursuant to the contract,
Dynasty Community Services LLC warrants against the workmanship of the installation of the work proposed.

This warranty does not cover damages to or failure of the products caused by the following: structural
defects, failure or settlement; improper drainage (standing water); fire, explosion, chemicals, fumes or
vapors; and damage or defects caused in whole or in part by reason of acts of God, flood, extreme weather
conditions, vandalism, negligence, or any other similar causes beyond the control of the contractor.

This Warranty is applicable only to the Association listed above.`,
  Other: ""
};


const QuoteForm = ({ existingQuote, onFinish, onCancel, showPreview = false }) => {
  const [formData, setFormData] = useState(existingQuote || {
    propertyId: "",  
    propertyName: "",
    management: "",
    managementAddress: "",
    projectTitle: "",
    description: "",
    total: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    additionalNotes: `NOTE: Please note that any change orders to the work proposed due to items discovered during demolition will be communicated to the owner and agreed upon before work commences.`,
    submittedBy: "",
    paymentTerms: "",
    fullPaymentTerms: "",
    warrantyType: "",
    fullWarranty: "",
  });
  
  const [properties, setProperties] = useState([]);
  const [users, setUsers] = useState([]);
  const [customPaymentTerms, setCustomPaymentTerms] = useState("");
  const [customWarranty, setCustomWarranty] = useState("");

  useEffect(() => {
    const loadProperties = async () => {
      const snap = await getDocs(collection(db, "properties"));
      const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a, b) => a.propertyName.localeCompare(b.propertyName));
      setProperties(list);
    };
    const loadUsers = async () => {
      const snap = await getDocs(collection(db, "users"));
      const list = snap.docs.map(doc => {
        const initials = `${doc.data().firstName[0] || ""}${doc.data().lastName[0] || ""}`;
        return { id: doc.id, initials };
      });
      setUsers(list);
    };
    loadProperties();
    loadUsers();
  }, []);

  useEffect(() => {
    if (existingQuote && properties.length > 0) {
      const matchedProperty = properties.find(
        (p) => p.propertyName === existingQuote.propertyName
      );
    
      setFormData((prev) => ({
        ...existingQuote,
        propertyId: matchedProperty?.id || "",  // <-- ADD THIS
        fullPaymentTerms:
          existingQuote.fullPaymentTerms ||
          paymentOptions[existingQuote.paymentTerms] ||
          "",
        fullWarranty:
          existingQuote.fullWarranty ||
          warrantyOptions[existingQuote.warrantyType] ||
          "",
      }));
    }
  }, [existingQuote, properties]);
  

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePropertySelect = async (e) => {
    const propertyId = e.target.value;
    const docRef = doc(db, "properties", propertyId);
    const propertySnap = await getDoc(docRef);
    const property = propertySnap.data();
    setFormData(prev => ({
      ...prev,
      propertyId: propertyId,
      propertyName: property.propertyName,
      management: property.management,
      managementAddress: property.managementAddress,
    }));
    
  };

  const handlePaymentChange = (e) => {
    const selected = e.target.value;
    setFormData((prev) => ({
      ...prev,
      paymentTerms: selected,
      fullPaymentTerms: paymentOptions[selected]
    }));
  };

  const handleCustomPayment = (e) => {
    const value = e.target.value;
    setCustomPaymentTerms(value);
    setFormData((prev) => ({
      ...prev,
      fullPaymentTerms: value
    }));
  };

  const handleWarrantyChange = (e) => {
    const selected = e.target.value;
    setFormData((prev) => ({
      ...prev,
      warrantyType: selected,
      fullWarranty: warrantyOptions[selected]
    }));
  };

  const handleCustomWarranty = (e) => {
    const value = e.target.value;
    setCustomWarranty(value);
    setFormData((prev) => ({
      ...prev,
      fullWarranty: value
    }));
  };

  const waitForImagesToLoad = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) return resolve();
          img.onload = img.onerror = resolve;
        })
    );
    return Promise.all(promises);
  };

  const generatePDFBlob = async () => {
    const page1 = document.getElementById("quote-page-1");
    const page2 = document.getElementById("quote-page-2");

    await waitForImagesToLoad(page1);
    await waitForImagesToLoad(page2);

    const canvas1 = await html2canvas(page1, { scale: 2 });
    const canvas2 = await html2canvas(page2, { scale: 2 });

    const pdf = new jsPDF("p", "mm", "a4");
    const width = 190;

    const height1 = (canvas1.height * width) / canvas1.width;
    pdf.addImage(canvas1.toDataURL("image/png"), "PNG", 10, 10, width, height1);

    pdf.addPage();
    const height2 = (canvas2.height * width) / canvas2.width;
    pdf.addImage(canvas2.toDataURL("image/png"), "PNG", 10, 10, width, height2);

    return pdf.output("blob");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const pdfBlob = await generatePDFBlob();
    const cleanFileName = `${formData.propertyName} - ${formData.projectTitle}`.replace(/[^a-zA-Z0-9 \-_]/g, "").trim();
    const storage = getStorage();
    const storageRef = ref(storage, `quotes/${cleanFileName}.pdf`);
    await uploadBytes(storageRef, pdfBlob);
    const pdfUrl = await getDownloadURL(storageRef);

    const docRef = existingQuote
      ? doc(db, "quotes", existingQuote.id)
      : collection(db, "quotes");

    const save = existingQuote ? updateDoc : addDoc;
    await save(docRef, {
      ...formData,
      pdfUrl,
      fullPaymentTerms: formData.fullPaymentTerms,
      fullWarranty: formData.fullWarranty,
      createdAt: serverTimestamp()
    });

    if (onFinish) onFinish();
  };

  return (
    <form onSubmit={handleSubmit}>
      <select
        name="propertyId"
        value={formData.propertyId || ""}
        onChange={handlePropertySelect}
        required
      >
        <option value="">Select Property</option>
        {properties.map(p => (
          <option key={p.id} value={p.id}>
            {p.propertyName}
          </option>
        ))}
      </select>
      <input name="projectTitle" placeholder="Scope of Work" value={formData.projectTitle} onChange={handleChange} required />
      <textarea name="description" placeholder="Description" value={formData.description} onChange={handleChange} />
      <input name="optionA" placeholder="Option A" value={formData.optionA} onChange={handleChange} />
      <input name="optionB" placeholder="Option B" value={formData.optionB} onChange={handleChange} />
      <input name="optionC" placeholder="Option C" value={formData.optionC} onChange={handleChange} />
      <input name="optionD" placeholder="Option D" value={formData.optionD} onChange={handleChange} />
      <textarea name="additionalNotes" value={formData.additionalNotes} onChange={handleChange} />
      <select name="submittedBy" value={formData.submittedBy} onChange={handleChange}>
        <option value="">Submitted By</option>
        {users.map(u => <option key={u.id} value={u.initials}>{u.initials}</option>)}
      </select>
      <select name="paymentTerms" value={formData.paymentTerms} onChange={handlePaymentChange}>
        <option value="">Payment Terms</option>
        {Object.keys(paymentOptions).map((key) => (
          <option key={key} value={key}>{key}</option>
        ))}
      </select>
      {formData.paymentTerms === "Other" && (
        <textarea
          value={customPaymentTerms}
          onChange={handleCustomPayment}
          placeholder="Enter custom payment terms..."
        />
      )}

      <select name="warrantyType" value={formData.warrantyType} onChange={handleWarrantyChange}>
        <option value="">Warranty Information</option>
        {Object.keys(warrantyOptions).map((key) => (
          <option key={key} value={key}>{key}</option>
        ))}
      </select>
      {formData.warrantyType === "Other" && (
        <textarea
          value={customWarranty}
          onChange={handleCustomWarranty}
          placeholder="Enter custom warranty details..."
        />
      )}
      <button type="submit">
        {existingQuote ? "Update Quote" : "Save Quote"}
      </button>
      <button type="button" onClick={onCancel} style={{ marginLeft: "10px" }}>
        Cancel
      </button>

      {showPreview && (
        <div style={{ border: "1px solid #999", marginTop: "20px" }}>
          <QuoteContent quote={formData} page="1" />
          <QuoteContent quote={formData} page="2" />
        </div>
      )}

      <div id="pdf-container" style={{ position: "fixed", left: "-10000px", top: "0px", zIndex: -9999 }}>
        <div id="quote-page-1">
          <QuoteContent quote={formData} page="1" />
        </div>
        <div id="quote-page-2">
          <QuoteContent quote={formData} page="2" />
        </div>
      </div>
    </form>
  );
};

export default QuoteForm;
